export default __webpack_public_path__ + "static/media/bg_home.0075892d.jpg";